module.exports = __webpack_public_path__ + "img/waerme-checkmark-b.f11f20aa.svg";